import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { KycQuestionnaireFormWidget } from "../../widgets/kycQuestionnaire/form";

export const KycQuestionnaireCreatePage = () => {
  const { _id } = useParams<{ _id: string }>();
  const id = _id ?? "create";
  useEffect(() => {
    document.title =
      id === "create" ? "KYC Судалгаа нэмэх" : "KYC Судалгаа засах";
  }, [id]);
  return (
    <div className="page">
      <KycQuestionnaireFormWidget _id={id} />
    </div>
  );
};
